module.exports = __webpack_public_path__ + "img/girl selected.587b63e1.png";